import PropTypes from 'prop-types';
import { Box, Flex, Text } from '@qga/roo-ui/components';
import { FormattedMoney } from 'components/Formatters';
import { NonWrappingText } from 'components/Typography';
import Divider from 'components/Divider';

const addSeparatorReducer = (renderSeparator) => (prev, curr, index) => [...prev, ...(prev.length ? [renderSeparator(index)] : []), curr];

export const Title = ({ children, fontWeight = 'bold' }) => (
  <Text fontSize="lg" fontWeight={fontWeight} color="greys.charcoal">
    {children}
  </Text>
);

export const Description = ({ children, fontWeight = 'bold' }) => (
  <Text fontSize="sm" fontWeight={fontWeight} color="emperor" as="div">
    {children}
  </Text>
);

export const Totals = ({ totals, fontWeight = 'bold' }) => (
  <Box textAlign="right">
    {totals
      .map((moneyProps, index) => (
        <NonWrappingText key={`currency_${index}`} fontSize="lg" fontWeight={fontWeight}>
          <FormattedMoney {...moneyProps} />
        </NonWrappingText>
      ))
      .reduce(
        addSeparatorReducer((index) => (
          <Text key={`divider_${index}`} fontSize="lg" fontWeight={fontWeight}>
            <Divider />
          </Text>
        )),
        [],
      )}
  </Box>
);

const BaseTotal = ({ title, totals, children, fontWeight, ...props }) => (
  <Flex px={5} justifyContent="space-between" alignItems="baseline" {...props}>
    <Box pr={5}>
      <Title fontWeight={fontWeight}>{title}</Title>
      <Description fontWeight={fontWeight}>{children}</Description>
    </Box>
    <Box flex="0 0 auto">
      <Totals fontWeight={fontWeight} totals={totals} />
    </Box>
  </Flex>
);

BaseTotal.propTypes = {
  ...Box.propTypes,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  totals: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
      currency: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default BaseTotal;
